import { Vector3 } from 'three';
import { ActionControllerEventName, ViewerModule, Tween, ResourcesManager } from '@verybigthings/vbt-webvr-framework';
export default class SanitizerModule extends ViewerModule {
    constructor(pointerController, level, sprayModule) {
        super();
        this.pointerController = pointerController;
        this.level = level;
        this.sprayModule = sprayModule;
        this.__inited = false;
    }
    spray(milliseconds) {
        this.alco.add(this.sprayModule.uiObject);
        this.sprayModule.uiObject.position.set(-0.0008566357671438637, 0.5821735817372315, 0.12460287794307759);
        this.sprayModule.uiObject.rotation.set(-2.57421047249976, -1.5164944393829072, 2.1388472444632045);
        this.sprayModule.uiObject.visible = true;
        setTimeout(() => {
            this.sprayModule.uiObject.visible = false;
            this.alco.remove(this.sprayModule.uiObject);
        }, milliseconds);
    }
    init(instruments) {
        let callback;
        this.alco = instruments.alco;
        this.actionController.on(ActionControllerEventName.click, this.alco, callback = () => {
            if (!this.level.interaction)
                return;
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            ResourcesManager.getAudioManger().getAudio('spray_sound').play();
            this.spray(400);
            const cap = this.alco.getObjectByName('cap');
            const oldPos = cap.position.clone();
            const targetPos = new Vector3(oldPos.x, oldPos.y - .05, oldPos.z);
            const tweenRotate = new Tween({ alpha: 0 }).to({ alpha: 1 }, 500)
                .onUpdate((alpha) => {
                let newPos;
                if (alpha <= .5) {
                    newPos = oldPos.clone().lerp(targetPos, alpha * 2);
                }
                else {
                    newPos = targetPos.clone().lerp(oldPos, (alpha - .5) * 2);
                }
                cap.position.copy(newPos);
            })
                .onComplete(() => {
                this.fire('hands_sanitised');
                // alert('hands_sanitised');
            })
                .start();
            this.actionController.off(ActionControllerEventName.click, this.alco, callback);
        });
    }
    // beforeReset() {
    //     this.instruments.alco.parent.remove(this.instruments.alco);
    // }
    //
    // reset() {
    //     this.actionController.off(ActionControllerEventName.click, this.table);
    //
    //     // if (this.areaContainer.parent) this.areaContainer.parent.remove(this.areaContainer);
    //     for (let i = this.areaContainer.children.length - 1; i >= 0; i--) {
    //         this.areaContainer.remove(this.areaContainer.children[i]);
    //     }
    //
    //     this.initFirstSpots();
    // }
    update() {
    }
}
